<template>
  <vx-card class="mt-base" :title="activityTitle">
    <p class="mb-5">
      (Please note: Some of these job titles and responsibilities may change slightly from state to
      state/jurisdiction to jurisdiction.)
    </p>
    <p class="mb-5">
      In later activities, we will take a look at a criminal case scenario from an actual criminal
      case at Victoria County Court. But, first, we need to look at some of the different jobs of
      those working in the court.
    </p>
    <p class="mb-5">
      The smooth running of a court requires the cooperation of many different roles and
      occupations. In the video below, you’ll gain an insight into the different roles and
      responsibilities of various people working at the County Court of Victoria.
    </p>
    <p class="mb-5">
      Watch the two short videos below. One is about how a civil case is organised, and the other
      about a criminal case. Then, answer the questions that follow.
    </p>

    <p class="mb-5 text-center"><strong>Civil Case:</strong></p>
    <centered-image-wrapper
      :image="videos[1].image"
      classes="2/3"
      class="cursor-pointer"
      label="Play video: Civil case, with Judge O'Neill, Head of the Common Law Division"
      @clicked="showIframePopup(videos[1].video)"
    />

    <p class="mb-5 text-center"><strong>Criminal Case:</strong></p>
    <centered-image-wrapper
      :image="videos[2].image"
      classes="2/3"
      class="cursor-pointer"
      label="Play video: Criminal case, with Chief Judge Peter Kidd"
      @clicked="showIframePopup(videos[2].video)"
    />

    <h4 class="mb-5">Task – Questions:</h4>
    <div v-for="(question, index) in questions" :key="index">
      <radio-buttons-wrapper
        v-model="data['question' + index]"
        :index="index + 1"
        :question="question"
        :is-editable="isEditable"
      />
    </div>
    <save-buttons :is-editable="isEditable" @save="save" />
    <p class="my-5">
      If you want to find out more about the work of key personnel at the county/district court,
      check out the fact sheet here.
    </p>
    <a :href="'content/law/county-court-work-and-key-personnel.pdf' | blob_url" target="_blank">
      <centered-image-wrapper
        alt="County Court work and key personnel (PDF) (opens in a new tab)"
        :image="image1"
      />
    </a>
  </vx-card>
</template>

<script>
import computed from '@/views/WorkExperiences/components/activity_js/computed';
import inject from '@/views/WorkExperiences/components/activity_js/inject';
import methods from '@/views/WorkExperiences/components/activity_js/methods';
import RadioButtonsWrapper from '@/views/WorkExperiences/components/ActivitiesBlocks/RadioButtonsWrapper';
export default {
  components: { RadioButtonsWrapper },
  data() {
    return {
      videos: {
        1: {
          image: require('@/assets/images/experiences/law/activity_5_civil_splash.jpg'),
          video: 'https://www.youtube.com/embed/V0WLM6aBKCY',
        },
        2: {
          image: require('@/assets/images/experiences/law/activity_5_criminal_splash.jpg'),
          video: 'https://www.youtube.com/embed/TBWs2pVVJ1I',
        },
      },
      image1: require('@/assets/images/experiences/law/law_activity_5_button.jpg'),
      questions: [
        {
          question: 'Who is responsible for briefing the barrister?',
          answers: [
            { val: 1, answer: 'The Tipstaff', correct: false },
            { val: 2, answer: 'The Solicitor', correct: true },
            { val: 3, answer: 'The Judge', correct: false },
          ],
        },
        {
          question: 'Who helps the judge organise the trial?',
          answers: [
            { val: 1, answer: 'The Judge’s Associate', correct: true },
            { val: 2, answer: 'The Solicitor', correct: false },
            { val: 3, answer: 'The Barrister', correct: false },
          ],
        },
        {
          question: 'Who assists the jury?',
          answers: [
            { val: 1, answer: 'The Tipstaff', correct: true },
            { val: 2, answer: 'The Judge’s Associate', correct: false },
            { val: 3, answer: 'The Judge', correct: false },
          ],
        },
        {
          question: 'In a civil case, how many jury members are there?',
          answers: [
            { val: 1, answer: '4', correct: false },
            { val: 2, answer: '6', correct: true },
            { val: 3, answer: '12', correct: false },
          ],
        },
        {
          question: 'In a criminal case, how many jury members are there?',
          answers: [
            { val: 1, answer: '4', correct: false },
            { val: 2, answer: '6', correct: false },
            { val: 3, answer: '12', correct: true },
          ],
        },
        {
          question: 'Who is responsible for imposing a sentence when necessary?',
          answers: [
            { val: 1, answer: 'The Prosecution Team', correct: false },
            { val: 2, answer: 'The Jury', correct: false },
            { val: 3, answer: 'The Judge', correct: true },
          ],
        },
      ],
    };
  },
  methods: methods,
  computed: computed,
  inject: inject,
};
</script>
